import { useLocation, useNavigate, useParams } from 'react-router-dom';

// Το react-router 6 εκθέτει τη διεύθυνση μόνο μέσω hooks, ενώ τα συστατικά της
// εφαρμογής είναι class components. Ο προσαρμογέας τα δίνει ως props, ώστε να μη
// χρειαστεί μετατροπή των συστατικών σε συναρτησιακά.
export default function withRouter(Component) {
    return function ComponentWithRouter(props) {
        return (
            <Component
                {...props}
                location={useLocation()}
                navigate={useNavigate()}
                params={useParams()}
            />
        );
    };
}
